<template>
  <button
    :class="[sizeClass, variantClass, { loading: loading }]"
    :disabled="disabled || loading"
    :type="type"
    @click="$emit('click')"
  >
    <span class="button-content-container" :class="{ loading: loading }">
      <slot></slot>
    </span>
    <transition
      enter-active-class="fadeInFast"
      mode="out-in"
    >
      <div v-if="loading" class="button-loader">
        <img
          :src="`${scBaseUrl}/assets/images/icons/preloadder.gif`"
          alt="Loading..."
        />
      </div>
    </transition>
  </button>
</template>

<script>
export default {
  name: "BaseButton",

  props: {
    variant: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "w-full",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
  },
  computed: {
    sizeClass() {
      return this.size;
    },
    variantClass() {
      return this.variant;
    },
  },
};
</script>



// WEBPACK FOOTER //
// BaseButton.vue?50b02716